import { render, staticRenderFns } from "./Empty.layout.vue?vue&type=template&id=57b4ae50&scoped=true&"
import script from "./Empty.layout.vue?vue&type=script&lang=ts&"
export * from "./Empty.layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b4ae50",
  null
  
)

export default component.exports